import { Disclaimer, DISCLAIMER_NAMES } from '@fff-web/cms';
import { appEnv } from '../../../utils/env';
import * as styles from './TermsAndConditions.module.scss';

export const SHIPPING_DISCLAIMER = `*Free shipping only applicable in the contiguous US.
  'Foreign exchange or transaction fees may apply for non US customers.`;

const TermsAndConditions = () => {
  const { reactivateMyMembership } = DISCLAIMER_NAMES;

  return (
    <div className={styles.termsAndConditionsWrapper}>
      <p className={styles.shippingDisclaimer} data-testid="shipping-disclaimer">
        {SHIPPING_DISCLAIMER}
      </p>
      <div className={styles.disclaimer} data-testid={`${reactivateMyMembership}-disclaimer`}>
        <Disclaimer name={reactivateMyMembership} env={appEnv} />
      </div>
    </div>
  );
};

export default TermsAndConditions;
